<template>
	<div class="app">
		<div class="title">
			<img src="@/assets/images/title.png" alt="" />
		</div>
		<div class="content">
			<transition name="fade">
				<img :src="imgs[index1]" alt="" class="msg1" v-show="show1" />
			</transition>
			<transition name="fade">
				<img :src="imgs[index2]" alt="" class="msg2" v-show="show2" />
			</transition>
			<transition name="fade">
				<img :src="imgs[index3]" alt="" class="msg3" v-show="show3" />
			</transition>
			<transition name="fade">
				<img :src="imgs[index4]" alt="" class="msg4" v-show="show4" />
			</transition>

			<img class="content-bg" src="../assets/images/home_bg_img.png" alt="" />

			<div class="footer">
				<div class="code">
					<template v-if="!isInvite">
						<div v-if="showCode">
							<p class="caption">Ta的配对码</p>
							<p class="text">{{ code }}</p>
							<img src="@/assets/images/copy_btn.png" alt="" class="copy" @click="copy"
								:data-clipboard-text="code" data-clipboard-action="copy" />
						</div>
						<div v-else class="code-did">
							来晚了，对方已经匹配了~
						</div>
					</template>
					<template v-else>
						<p class="invite-code"><span>Ta正在请求和你匹配，</span></p>
						<p class="invite-code"><span>快去看看吧～</span></p>
					</template>

				</div>

				<div class="btn-container" :class="{'btn-disabled': !showCode}">
					<div class="btn" @click="openApp">
						<p v-if="showCode">点击去心动日常{{ isInvite ? "处理" : "填写" }}</p>
						<p v-else>对方已匹配</p>
					</div>
					<div class="wx-open-btn" v-if="isAndroidWx && showCode">
						<wx-open-launch-app id="launchBtn" appid="wxaae3a88835c40047" :extinfo="extinfo"
							@error="handleErrorFn" @launch="handleLaunchFn">
							<script type="text/wxtag-template">
								<style>
									.download {
										width: 17.6rem;
										height: 3.325rem;
										opacity: 0;
									}
								</style>
								<div class="download"></div>
							</script>
						</wx-open-launch-app>
					</div>

				</div>
			</div>
		</div>


		<div class="toast" v-show="toastFlag">{{ toastMsg }}</div>
		<div class="share" v-show="showFlag" @click="show">
			<img src="@/assets/images/share.png" alt="" />
		</div>
	</div>
</template>

<script>
const imgs = [
	require("@/assets/images/msg01.png"),
	require("@/assets/images/msg02.png"),
	require("@/assets/images/msg03.png"),
	require("@/assets/images/msg04.png"),
	require("@/assets/images/msg05.png"),
	require("@/assets/images/msg06.png"),
	require("@/assets/images/msg07.png"),
	require("@/assets/images/msg08.png")
];
import { device, getQueryParams } from 'wnl-xdsdk'
import { useOpenApp, useInitSDK, useCheckVersion } from '../hooks/openApp'
import { getCode } from '../api/index'

export default {
	data () {
		return {
			isAndroidWx: device.isAndroid && device.isWx,
			code: "",
			// code: '',
			toastMsg: "复制匹配码成功，前往心动日常填写",
			toastFlag: false,
			showFlag: false,
			imgs,
			show1: false,
			show2: false,
			show3: false,

			show4: false,
			index1: 0,
			index2: 1,
			index3: 2,
			index4: 3,
			duration: 400, //动画时间
			showDuration: 1000, //显示时间\
			urlLink: "https://qiniu.other.cq-wnl.com/publish-normal64-2.2.5-2020050.apk",
			showCode: true,
			isInvite: false
		};
	},
	computed: {
		extinfo() {
			return `ylcloser://query?code=${this.code}`
		}
	},
	created () {
		const userid = getQueryParams('userid', "")
		const from = getQueryParams("from", "")
		useCheckVersion().then(url => {
			this.urlLink = url
		})

		if (from !== 'invite') {
			getCode({ userid: userid }).then(res => {
				if (res.status == 200) {
					if (res.data) {
						this.code = res.data
						this.showCode = true
					} else {
						this.showCode = false
					}
				} else {
					this.showCode = false
				}
			})
		} else {
			this.isInvite = true
		}

	},
	methods: {
		handleErrorFn (e) {
			const { errMsg, appId, extInfo } = e.detail;
			window.location.href = 'https://sj.qq.com/appdetail/com.youloft.icloser?fromcase=40002&from_wxz=1#opened'
		},
		handleLaunchFn () {
			console.log('launch');
		},
		show () {
			this.showFlag = false;
		},
		trackEvent (name, type) {
			if (window._czc && typeof window._czc.push === "function") {
				window._czc.push(["_trackEvent", name, type]);
			}
			// console.log(eventStr, type);
		},
		openApp () {
			const { isAndroid, isIos, isWx } = device
			if (isAndroid) {
				if (!isWx) {
					let app = "ylcloser://query?code=" + this.code;
					useOpenApp(app, this.urlLink)
					this.trackEvent("Invite.Open.CK", "android");
				}
			} else {
				if (isIos) {
					if (isWx) {
						const url = "https://www.51wnl-cq.com/closer/?path=match&code=" + this.code;
						useOpenApp(url)
					} else {
						let app = "ylcloser://match?code=" + this.code;
						this.trackEvent("Invite.Open.CK", "ios");
						useOpenApp(app, 'itms-apps://itunes.apple.com/app/id1534020402')
					}
				}
			}
		},
		copy () {
			let clipboard = new this.clipboard(".copy");
			clipboard.on("success", (e) => {
				this.toastMsg = "复制匹配码成功，前往心动日常填写";
				this.toastFlag = true;
				clipboard.destroy();
			});
			clipboard.on("error", (e) => {
				this.toastMsg = "复制失败";
				this.toastFlag = true;
				clipboard.destroy();
			});
			setTimeout(() => {
				this.toastFlag = false;
			}, 2000);
		},
		change () {
			const index = parseInt(Math.random() * 10) % 8;
			this.index1 = index;
			this.show1 = true;
			setTimeout(() => {
				this.show1 = false;
			}, this.duration + this.showDuration);

			setTimeout(() => {
				this.index2 = (index + 1) % 8;
				this.show2 = true;
				setTimeout(() => {
					this.show2 = false;
				}, this.duration + this.showDuration);
			}, this.duration + this.showDuration / 2);

			setTimeout(() => {
				this.index3 = (index + 2) % 8;
				this.show3 = true;
				setTimeout(() => {
					this.show3 = false;
				}, this.duration + this.showDuration);
				setTimeout(() => {
					this.index4 = (index + 3) % 8;
					this.show4 = true;
					setTimeout(() => {
						this.show4 = false;
					}, this.duration + this.showDuration);
				}, this.duration + this.showDuration / 2);
			}, 200);
		},
		loop () {
			setInterval(() => {
				this.change();
			}, this.duration * 2.5 + this.showDuration * 2);
			this.change();
		},
	},
	mounted () {
		this.loop();
		if (this.isAndroidWx) {
			useInitSDK()
		}

		if (device.isAndroid) {
			this.trackEvent("Invite.IM", "android");
		} else {
			this.trackEvent("Invite.IM", "ios");
		}
	}
};
</script>
<style></style>

<style scoped>
.content {
	width: 94vw;
	height: 49.5vw;
	margin-left: 1vw;
	position: absolute;
	top: 38%;
	left: 50%;
	transform: translate(-50%, -50%);
}

.content-bg {
	width: 96vw;
	height: auto;
	display: block;
	position: absolute;
	top: 80%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 5;
}

.msg1,
.msg2,
.msg3,
.msg4 {
	width: 22vw;
	height: 11vw;
	display: block;
	position: absolute;
	z-index: 10;
}

.msg1 {
	top: 60%;
	margin-top: -5.5vw;
	/* transform: translateY(-50%); */
	left: 0;
}

.msg2 {
	top: 0;
	left: 20%;
}

.msg3 {
	right: 0;
	top: 5%;
}

.msg4 {
	right: 10%;
	bottom: 0;
}

.app {
	width: 100%;
	min-height: 100vh;
	overflow: hidden;
	background-image: url('../assets/images/home_bg.png');
	background-size: 100% auto;
	background-repeat: repeat-y;
	padding-top: 6vw;
	box-sizing: border-box;
	position: relative;
}

.title {
	width: 60.3vw;
	height: 26vw;
	margin: 0 auto;
	position: relative;
	z-index: 1;
}

img {
	width: 100%;
	display: block;
}

.footer {
	width: 76.8vw;
	/* height: 63.5vw; */
	position: absolute;
	top: 108%;
	z-index: 8;
	left: 50%;
	transform: translateX(-50%);
}

.invite-code {
	font-size: 34px;
	font-family: PingFang SC;
	font-weight: 500;
	color: #050505;
	line-height: 53px;
	position: relative;
	/* z-index: 1; */
}

.invite-code span {
	position: relative;
	z-index: 10;
}

.invite-code::before {
	content: "";
	display: block;
	position: absolute;
	left: 50%;
	bottom: 10%;
	transform: translateX(-50%);
	width: 110%;
	height: 19px;
	background-color: #FFF9BB;
	border-radius: 19px;
	z-index: 0;
}

.code {
	width: 76.8vw;
	height: 49.7vw;
	background-image: url('../assets/images/border.png');
	background-size: 100% 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	box-sizing: border-box;
	padding-top: 3vw;
}

.code>div {
	width: 70%;
	height: auto;
	text-align: center;
}

.code-did {
	color: #000000;
	font-size: 34px;
	display: flex;
	align-items: center;
	justify-content: center;
	transform: scale(1.1);
}

.caption {
	font-size: 30px;
	font-family: PingFang SC;
	font-weight: 400;
	color: #050505;
	/* line-height: 47px; */
}

.text {
	margin: 3.5vw 0;
	font-size: 60px;
	font-family: DIN Alternate;
	font-weight: bold;
	color: #000000;
}

.copy {
	width: 18.67vw;
	display: block;
	margin: 0 auto;
}

.btn-container {
	margin-left: 50%;
	transform: translateX(-50%);
	width: 70.3vw;
	height: 13.3vw;
	position: relative;
}

.btn-disabled {
	filter: grayscale();
	-webkit-filter: grayscale();
	opacity: 0.6;
	pointer-events: none;
}

.btn {
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 9;
	background-image: url('../assets/images/home_btn.png');
	background-size: 100% 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}

.btn p {
	font-size: 28px;
	font-family: PingFang SC;
	font-weight: 600;
	color: #FFFFFF;
	line-height: 28px;
}

.wx-open-btn {
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 10;
}

.toast {
	padding: 0 20px;
	z-index: 500;
	text-align: center;
	height: 8vw;
	line-height: 8vw;
	font-size: 30px;
	/* width: 80vw; */
	white-space: nowrap;
	max-width: 80vw;
	min-width: 24vw;
	border-radius: 4vw;
	background-color: rgba(0, 0, 0, 0.5);
	color: white;
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}

.share {
	z-index: 1000;
	width: 100vw;
	height: 100vh;
	position: fixed;
	top: 0px;
	left: 0px;
	background-color: rgba(0, 0, 0, 0.5);
}

.share>img {
	display: block;
	width: 100%;
	height: auto;
}

/*长屏手机 */
@media screen and (max-aspect-ratio: 375 / 710) {
	.content {
		top: 42%;
	}

	.btn-container {
		margin-top: 15.87vw;
	}
}

.fade-enter-to,
.fade-leave {
	transform: scale(1);
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
	{
	transform: scale(0);
}

.fade-enter-active,
.fade-leave-active {
	/* transform: scale(0.3); */
	transition: all 0.4s ease;
}
</style>
